import React from 'react'

import {
  ResizedProductImage,
  ResizedProductImageProps,
} from '../ResizedProductImage'

export const ProductCarouselImage = (props: ResizedProductImageProps) => {
  return <ResizedProductImage {...props} />
}
